module.exports = __webpack_public_path__ + "img/1440.5d098ca2.jpg";